import styled from '@emotion/styled';

export const InfoContainer = styled.div`
  margin:5%;
`;

export const MessageBody = styled.span`
  white-space: pre-line;
  margin: 15px 0px;
  text-align: center;
  line-height: 2;
  font-size: 16px;
  color: #27344c;
`;